module.exports = __webpack_public_path__ + "media/unipod/icon-delivery-black-b5fe5de4.svg";